import { render } from "./Astrologs.vue?vue&type=template&id=e75d6688&scoped=true"
import script from "./Astrologs.vue?vue&type=script&lang=js"
export * from "./Astrologs.vue?vue&type=script&lang=js"

import "./Astrologs.vue?vue&type=style&index=0&id=e75d6688&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e75d6688"]])

export default __exports__